import { render, staticRenderFns } from "./tax.vue?vue&type=template&id=4d1d666b&scoped=true&"
import script from "./tax.vue?vue&type=script&lang=js&"
export * from "./tax.vue?vue&type=script&lang=js&"
import style0 from "./tax.vue?vue&type=style&index=0&id=4d1d666b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1d666b",
  null
  
)

export default component.exports